module.exports = __webpack_public_path__ + "img/pProfile.2ffdc2c9.png";